export function formatNames ( names: ( string | undefined | null )[] | null | undefined ): string | null {
  const filtered = names?.filter( Boolean ) as string[] || [];
  if ( filtered.length === 0 ) return null;
  if ( filtered.length === 1 ) return filtered[0];
  if ( filtered.length === 2 ) return `${filtered[0]} and ${filtered[1]}`;
  return `${filtered.slice( 0, -1 ).join( ", " )} and ${filtered[filtered.length - 1]}`;
}

export function escapeRegExp ( str: string ) {
  return str.replace( /[.*+\-?^${}()|[\]\\]/g, "\\$&" ); // $& means the whole matched string
}

/**
 *
 * @param a the first string
 * @param b the second string
 * @return -1 if a is less than b,
 * +1 if a is greater than b
 * 0 if a === b
 */
export function compareStrings ( a: string, b: string ) {
  const na = a.toUpperCase();
  const nb = b.toUpperCase();

  if ( na < nb ) {
    return -1;
  }

  if ( na > nb ) {
    return -1;
  }

  return 0;
}
